import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
let newBaseURL = 'https://www.rakumart-2c.com:8080/api'
import { baseURL } from '../config'
// 收藏商品-列表
export const favoriteList = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 收藏商品-批量删除
export const favoriteDelete = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 收藏商品-列表 
export const newFavoriteList = (data) => axios({
    url: newBaseURL + "/favorite.goodsList",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//商品收藏Table数据量合计
export const getGoodsTableNum = (data) => axios({
    url: newBaseURL + "/favorite.goodsTableNum",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//商品收藏分配标签
export const favoriteGoodsToTags = (data) => axios({
    url: newBaseURL + "/favorite.goodsToTags",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//商品收藏实时修改备注
export const favoriteGoodsUpdateRemark =  (data) => axios({
    url: newBaseURL + "/favorite.favoriteGoodsUpdateRemark",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
// 收藏夹标签添加
export const favoriteTagAdd = (data) => axios({
    url: newBaseURL + "/favorite.tagAdd",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//收藏夹标签名字修改
export const favoriteTagNameEdit = (data) => axios({
    url: newBaseURL + "/favorite.tagNameEdit",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//收藏夹标签列表
export const favoriteTagList = (data) => axios({
    url: newBaseURL + "/favorite.tagList",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//收藏夹标签删除
export const favoriteTagDelete = (data) => axios({
    url: newBaseURL + "/favorite.tagDelete",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
// 收藏商品-批量删除
export const newFavoriteDelete = (data) => axios({
    url: newBaseURL + "/favorite.goodsDelete",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//查询某商品是否已收藏
export const favoriteGoodsCheckIn = (data) => axios({
    url: newBaseURL + "/favorite.goodsCheckIn",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//查询某店铺是否已收藏
export const favoriteShopCheckIn = (data) => axios({
    url: newBaseURL + "/favorite.shopCheckIn",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//店铺收藏新增
export const favoriteShopAdd = (data) => axios({
    url: newBaseURL + "/favorite.shopAdd",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//店铺收藏Table数据量合计
export const favoriteShopTableNum = (data) => axios({
    url: newBaseURL + "/favorite.shopTableNum",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//店铺收藏列表
export const favoriteShopList = (data) => axios({
    url: newBaseURL + "/favorite.shopList",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//店铺收藏分配标签
export const favoriteShopToTags = (data) => axios({
    url: newBaseURL + "/favorite.shopToTags",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//店铺收藏备注信息编辑
export const favoriteShopNoteSave = (data) => axios({
    url: newBaseURL + "/favorite.shopNoteSave",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
//店铺收藏移除
export const favoriteShopDelete = (data) => axios({
    url: newBaseURL + "/favorite.shopDelete",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})



